export default __webpack_public_path__ + "static/media/Tutorial-Step-4.1.e34038c9.jpg";